import './front.js';
import './front.scss';



// WEBPACK FOOTER //
// ./front/index.js